export const MODALS_STACK_NAME = Symbol(__DEV__ ? 'modals stack' : '');
